// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-tabs-container {
  position: relative;
  width: 100%;
  border: 2px solid rgb(0, 150, 255);
  border-radius: 12px;
  box-sizing: border-box;
  background: #000;
  overflow: hidden;
}

.progress-tabs-container.mini {
  min-height: 32px;
  height: 40px;
  border-radius: 8px;
}

.progress-bar-area {
  position: relative;
  width: 100%;
  height: 12px;
}

.progress-bar,
.progress-bar-segments {
  position: absolute;
  left: 0;
  top: 0;
  height: 12px;
}

.progress-bar {
  background: rgb(0, 150, 255);
  transition: width 0.3s ease;
  z-index: 1;
}

.progress-bar-segments {
  width: 100%;
  pointer-events: none;
  z-index: 2;
}

.progress-bar-segment {
  position: absolute;
  top: 0;
  width: 2px;
  height: 12px;
  background: rgb(0, 150, 255);
  opacity: 0.7;
}

.progress-tabs-wrapper {
  display: block;
}

@media (max-width: 1200px) {
  .progress-tabs-wrapper {
    display: none;
  }
}

.progress-tabs {
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-tab {
  padding: 0.5rem 1rem;
  margin: 0 0.5rem;
  border-radius: 4px;
  background: transparent;
  color: rgb(0, 150, 255);
  font-weight: normal;
  /* cursor: pointer; */
  cursor: not-allowed;
  transition: background 0.3s, color 0.3s;
}

.progress-tab.active {
  background: rgb(0,50, 111);
  color: white;
  font-weight: bold;
}

.progress-arrow {
  color: rgba(0, 150, 255, 0.3);
  font-size: 3rem;

  /* bold  */
  font-weight: bold;

  /* Shift them up by 0.5rem; */
    transform: translateY(-0.5rem);
}

.progress-bar-overlay-text {
  position: absolute;
  left: 0;
  top: 0;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
  font-size: 0.95rem;
  pointer-events: none;
  white-space: nowrap;
  z-index: 3;
  overflow: hidden;
}

.progress-bar-overlay-text.mini {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto !important;
  min-width: 80px;
  height: auto;
  padding: 0.2rem 0.7rem;
  background: rgba(0, 150, 255, 0.85);
  color: #fff;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  z-index: 10;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ProgressTabs.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;;EAEf,UAAU;EACV,iBAAiB;;EAEjB,6BAA6B;IAC3B,8BAA8B;AAClC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".progress-tabs-container {\n  position: relative;\n  width: 100%;\n  border: 2px solid rgb(0, 150, 255);\n  border-radius: 12px;\n  box-sizing: border-box;\n  background: #000;\n  overflow: hidden;\n}\n\n.progress-tabs-container.mini {\n  min-height: 32px;\n  height: 40px;\n  border-radius: 8px;\n}\n\n.progress-bar-area {\n  position: relative;\n  width: 100%;\n  height: 12px;\n}\n\n.progress-bar,\n.progress-bar-segments {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 12px;\n}\n\n.progress-bar {\n  background: rgb(0, 150, 255);\n  transition: width 0.3s ease;\n  z-index: 1;\n}\n\n.progress-bar-segments {\n  width: 100%;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.progress-bar-segment {\n  position: absolute;\n  top: 0;\n  width: 2px;\n  height: 12px;\n  background: rgb(0, 150, 255);\n  opacity: 0.7;\n}\n\n.progress-tabs-wrapper {\n  display: block;\n}\n\n@media (max-width: 1200px) {\n  .progress-tabs-wrapper {\n    display: none;\n  }\n}\n\n.progress-tabs {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.progress-tab {\n  padding: 0.5rem 1rem;\n  margin: 0 0.5rem;\n  border-radius: 4px;\n  background: transparent;\n  color: rgb(0, 150, 255);\n  font-weight: normal;\n  /* cursor: pointer; */\n  cursor: not-allowed;\n  transition: background 0.3s, color 0.3s;\n}\n\n.progress-tab.active {\n  background: rgb(0,50, 111);\n  color: white;\n  font-weight: bold;\n}\n\n.progress-arrow {\n  color: rgba(0, 150, 255, 0.3);\n  font-size: 3rem;\n\n  /* bold  */\n  font-weight: bold;\n\n  /* Shift them up by 0.5rem; */\n    transform: translateY(-0.5rem);\n}\n\n.progress-bar-overlay-text {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: bold;\n  font-size: 0.95rem;\n  pointer-events: none;\n  white-space: nowrap;\n  z-index: 3;\n  overflow: hidden;\n}\n\n.progress-bar-overlay-text.mini {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: auto !important;\n  min-width: 80px;\n  height: auto;\n  padding: 0.2rem 0.7rem;\n  background: rgba(0, 150, 255, 0.85);\n  color: #fff;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: bold;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.12);\n  z-index: 10;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
